// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".time-preview[data-v-48df9654]{align-items:center;cursor:pointer;display:flex;height:67px;justify-content:space-between;padding:0 16px;width:100%}.time-preview__no-settings[data-v-48df9654]{color:#f25248}.time-preview__img[data-v-48df9654]{margin-left:8px}.time-preview__state[data-v-48df9654]{align-items:center;display:flex;justify-content:center}.time-preview__state .h7[data-v-48df9654]{font-weight:600}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
